import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { FuseWidgetModule } from "@fuse/components";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { StatusMovimentacaoService } from "app/auxiliares/services/status-movimentacao.service";
import { ClienteService } from "app/clientes/services/cliente.service";
import { RegionalService } from "app/empreendimento/services/regional.service";
import { EscritorioService } from "app/empresas/services/escritorio.service";
import { MovimentacaoModule } from "app/movimentacao/movimentacao.module";
import { NgChartsModule } from "ng2-charts";
import { CurrencyMaskModule } from "ng2-currency-mask";
// import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
// import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FechamentoCartaConsorcioService } from "app/auxiliares/services/fechamento-carta-consorcio-service";
import { OperadorCartaConsorcioService } from "app/auxiliares/services/operador-carta-consorcio-service";
import { ParceiroCartaConsorcioService } from "app/auxiliares/services/parceiro-carta-consorcio-service";
import { StatusCartaConsorcioService } from "app/auxiliares/services/status-carta-consorcio-service";
import { FileUploadModule } from "ng2-file-upload";
import { AuthService } from "../base-module/base-service/auth.service";
import { BaseModule } from "../base-module/base.module";
import { CadastroBoletaConsorcioComponent } from "./cadastro-boleta-consorcio/cadastro-boleta-consorcio.component";
import { CadastroCaracteristicaProdutoConsorcioComponent } from "./cadastro-caracteristica-produto-consorcio/cadastro-caracteristica-produto-consorcio.component";
import { CadastroCarteiraConsorcioComponent } from "./cadastro-carteira-consorcio/cadastro-carteira-consorcio.component";
import { CadastroEmpresaConsorcioComponent } from "./cadastro-empresa-consorcio/cadastro-empresa-consorcio.component";
import { CadastroLancesBoletaConsorcioComponent } from "./cadastro-lances-boleta-consorcio/cadastro-lances-boleta-consorcio.component";
import { CadastroTipoConsorcioComponent } from "./cadastro-tipo-consorcio/cadastro-tipo-consorcio.component";
import { ConsorcioRoutes } from "./consorcio.routing";
import { DashboardConsorcioComponent } from "./dashboard-consorcio/dashboard-consorcio.component";
import { ListaBoletaConsorcioComponent } from "./lista-boleta-consorcio/lista-boleta-consorcio.component";
import { ListaCaracteristicaProdutoCosorcioComponent } from "./lista-caracteristica-produto-consorcio/lista-caracteristica-produto-consorcio.component";
import { ListaClienteCarteiraConsorcioComponent } from "./lista-cliente-carteira-consorcio/lista-cliente-carteira-consorcio.component";
import { ListaEmpresaCosorcioComponent } from "./lista-empresa-consorcio/lista-empresa-consorcio.component";
import { ListaTipoCosorcioComponent } from "./lista-tipo-consorcio/lista-tipo-consorcio.component";
import { CadastroCartaBoletaConsorcio } from "./manter-carta-boleta-consorcio/cadastro-carta-boleta-consorcio.component";
import { FiltroCartaBoletaConsorcioComponent } from "./manter-carta-boleta-consorcio/filtro-carta-boleta-consorcio/filtro-carta-boleta-consorcio.component";
import { ListaCartaBoletaConsorcio } from "./manter-carta-boleta-consorcio/lista-carta-boleta-consorcio.component";
import { BoletaConsorcioService } from "./services/boleta-consorcio.service";
import { CaracteristicaProdutoConsorcioService } from "./services/caracteristica-produto-consorcio.service";
import { CartaBoletaConsorcioService } from "./services/carta-boleta-consorcio.service";
import { ClienteCarteiraConsorcioService } from "./services/cliente-carteira-consorcio.service";
import { DashboardConsorcioService } from "./services/dashboard-consorcio.service";
import { EmpresaConsorcioService } from "./services/empresa-consorcio.service";
import { LanceCartaConsorcioService } from "./services/lance-carta-consorcio.service";
import { TipoConsorcioService } from "./services/tipo-consorcio.service";
import { TipoLanceCartaConsorcioService } from "./services/tipo-lance-carta-consorcio.service";
import { VisualizarBoletaConsorcioComponent } from "./visualizar-boleta-consorcio/visualizar-boleta-consorcio.component";
import { VisualizarCarteiraConsorcioComponent } from "./visualizar-carteira-consorcio/visualizar-carteira-consorcio.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(ConsorcioRoutes),
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatGridListModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatListModule,
        MatRippleModule,
        MatDialogModule,
        BaseModule,
        FileUploadModule,
        MatMenuModule,
        CurrencyMaskModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatDatepickerModule,
        NgxChartsModule,
        NgChartsModule,
        FuseWidgetModule,
        DragDropModule,
        MovimentacaoModule,
        // NgxShimmerLoadingModule,
        MatExpansionModule,
        MatTableModule,
    ],
    declarations: [
        ListaTipoCosorcioComponent,
        CadastroTipoConsorcioComponent,
        ListaEmpresaCosorcioComponent,
        CadastroEmpresaConsorcioComponent,
        ListaCaracteristicaProdutoCosorcioComponent,
        CadastroCaracteristicaProdutoConsorcioComponent,
        ListaBoletaConsorcioComponent,
        CadastroBoletaConsorcioComponent,
        ListaClienteCarteiraConsorcioComponent,
        CadastroCarteiraConsorcioComponent,
        VisualizarBoletaConsorcioComponent,
        VisualizarCarteiraConsorcioComponent,
        DashboardConsorcioComponent,
        CadastroLancesBoletaConsorcioComponent,
        ListaCartaBoletaConsorcio,
        CadastroCartaBoletaConsorcio,
        FiltroCartaBoletaConsorcioComponent,
    ],
    providers: [
        AuthService,
        TipoConsorcioService,
        EmpresaConsorcioService,
        CaracteristicaProdutoConsorcioService,
        BoletaConsorcioService,
        ClienteService,
        StatusMovimentacaoService,
        ClienteCarteiraConsorcioService,
        EscritorioService,
        RegionalService,
        DashboardConsorcioService,
        OperadorCartaConsorcioService,
        FechamentoCartaConsorcioService,
        StatusCartaConsorcioService,
        ParceiroCartaConsorcioService,
        CartaBoletaConsorcioService,
        TipoLanceCartaConsorcioService,
        LanceCartaConsorcioService,
    ],
})
export class ConsorcioModule {}
